import React from "react";
import { Link } from "react-router-dom";
import buttonarrowactive from "../assets/Buttonarrow.svg";

const ServiceCardButton  = ({ label = "Click Me", to = "/" }) => {
  return (
    <Link
      to={to}
      className="inline-flex font-generalsans-description  items-center justify-between rounded-full py-[6px] pr-[8px] pl-[16px] transition-colors duration-300   md:text-[16px] "
      style={{
        backgroundColor: "#FFFFFF",
        color: "#2C3075",
        textDecoration: "none",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "#CFCFDF";
        e.currentTarget.style.color = "#2C3075";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "#FFFFFF";
        e.currentTarget.style.color = "#2C3075";
      }}
    >
      {/* Label */}
      <span className="mr-4">{label}</span>

      {/* Arrow image directly */}
      <img src={buttonarrowactive} alt="arrow" className="w-8 h-8" />
    </Link>
  );
};

export default ServiceCardButton;